module.exports = __webpack_public_path__ + "static/media/Logo_mini_blue.278ef109.svg";